<template>
   <ul>
        <span v-if="p">
            <div class="w-full flex flex-wrap items-center justify-start gap-3">
                <div>
                    {{ p.name }} - {{p.id}}
                </div>
                <div>
                    <input type="number" v-model="p.order" class="p-2 w-20 bg-slate-700 text-slate-100 border" placholder="order" />
                </div>
                <div>
                    <input type="number" placeholder="image id" v-model="p.image_id" class="p-2 w-20 bg-slate-700 text-slate-100 border" />
                </div>
                <div>
                    <input type="text" v-model="p.class" placeholder="class" class="p-2 flex-1 bg-slate-700 text-slate-100 border" />
                </div>
                <div>
                    <input type="text" v-model="p.title" class="p-2 flex-1 bg-slate-700 text-slate-100 border" />
                </div>
            </div>
            <textarea v-model="p.content" class="bg-slate-800 w-full md:w-3/4 min-h-64 p-4"  />
            <div class="w-full">
                <button @click="saveData(p.id, p.content, p.order, p.class, p.title, p.image_id)">SAVE</button>
            </div>
        </span>

   </ul>
</template>

<script type="text/javascript">
import { router } from '@inertiajs/vue3';

export default {
    name: "ParaObject",
    props: ['object'],
    computed: {
        p() {
            return this.object;
        }
    },
    data() {
       return {

       }
    },
    mounted() {

    },
    methods: {
        saveData(id, content, order, classes, title, image_id) {
            router.post('/post-content', {id: id, content: content, order: order, class: classes, title: title, image_id: image_id});
        }
    }
}
</script>
<style lang="css" scoped>
button {
    background-color: hsl(100,50%, 80%);
    color: black;
    font-weight: bold;
    padding: 3px 36px;
    margin: 10px 3px;
}
</style>
